module.exports = __webpack_public_path__ + "static/media/KIDS.d185f32d.webp";